export function _t(value: string): string {
  return value;
}
